import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { PlanCode, getPlanDefinition } from "@/lib/subscriptions";

interface UpgradeNoticeProps {
  title: string;
  description: string;
  targetPlan?: PlanCode;
}

export function UpgradeNotice({
  title,
  description,
  targetPlan = "professional",
}: UpgradeNoticeProps) {
  const plan = getPlanDefinition(targetPlan);

  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardContent className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <Badge className="w-fit bg-primary text-primary-foreground">
            <Sparkles className="mr-1 h-3.5 w-3.5" />
            Upgrade to {plan.name}
          </Badge>
          <div>
            <h3 className="text-base font-semibold text-foreground">{title}</h3>
            <p className="mt-1 max-w-2xl text-sm leading-6 text-muted-foreground">{description}</p>
          </div>
        </div>
        <Button asChild>
          <Link to={`/checkout?plan=${plan.code}&interval=monthly`}>
            View {plan.name}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
